import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { AnaliticsTableType } from 'components/AnalyticsPage/AnalyticsPageTypes';

export interface AnaliticsPageState {
  currentAnalyticsPage: AnaliticsTableType;
}

export const initialState: AnaliticsPageState = {
  currentAnalyticsPage: AnaliticsTableType.MouseTrapsAnalytics,
};

const analiticsPageReducer = createSlice({
  name: 'Analitics',
  initialState,
  reducers: {
    setCurrentAnalyticsPage(state, action: PayloadAction<AnaliticsTableType>) {
      state.currentAnalyticsPage = action.payload;
    },
  },
});

export const { setCurrentAnalyticsPage } = analiticsPageReducer.actions;

export default analiticsPageReducer.reducer;
